import React from 'react';
import { 
  Card,
  CardContent,
  CardHeader,
  Divider,
  Collapse,
  IconButton,
  Typography
} from '@mui/material';
import { Notes as NotesIcon, ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from '@mui/icons-material';
import ProductNote from '../productMeta/ProductNote.jsx';

const ProductNotesSection = ({ productId, expanded, toggleSection }) => {
  return (
    <Card sx={{ mt: 4, borderLeft: '4px solid #607d8b' }}>
      <CardHeader
        avatar={<NotesIcon style={{ color: '#607d8b' }} />}
        title={
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#607d8b' }}>
            Product Notes
          </Typography>
        }
        action={
          <IconButton onClick={() => toggleSection('notes')}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        sx={{ backgroundColor: '#f5f5f5' }}
      />
      <Divider />
      <Collapse in={expanded}>
        <CardContent>
          <ProductNote productId={productId} />
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default ProductNotesSection;
